module.exports = __webpack_public_path__ + "img/jd-fulltime.7fbecb52.svg";